<template>
  <div class="gauge">
    <div class="gauge__body">
      <div class="gauge__fill"></div>
      <div class="gauge__cover">
        <div class="gauge__text">Iniciando</div>
        <div class="gauge__score-text"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gauge',
  props: ['question', 'points'],
  data () {
    return {
      onLoad: false
    }
  },
  watch: {
    'question.show': function (val, oldVal) {
      if (val) this.init()
    },
    onLoad: function (val, oldVal) {
      if (val) this.$emit('nextStep', this.question)
    }
  },
  methods: {
    setGaugeValue: function (gauge, value, end) {
      if (value < 0 || value > 70) return
      const fillElement = gauge.querySelector('.gauge__fill')
      const textElement = gauge.querySelector('.gauge__text')
      const scoreTextElement = gauge.querySelector('.gauge__score-text')

      fillElement.style.transform = `rotate(${(value / 70) * 0.5}turn)`

      let scoreText = ''
      let scoreClass = ''

      if (value <= 20) {
        scoreText = 'Baixo'
        scoreClass = 'low-score'
      } else if (value <= 40) {
        scoreText = 'Médio'
        scoreClass = 'medium-score'
      } else if (value <= 60) {
        scoreText = 'Bom'
        scoreClass = 'high-score'
      } else {
        scoreText = 'Excelente'
        scoreClass = 'excellent-score'
      }

      fillElement.className = `gauge__fill ${scoreClass}`
      textElement.textContent = scoreText
      textElement.className = `gauge__text ${scoreClass}`
      scoreTextElement.className = `gauge__score-text ${scoreClass}`
      scoreTextElement.textContent = `${Math.round(value)} pontos`

      if (end) {
        setTimeout(() => {
          this.onLoad = true
        }, 3000)
      }
    },
    simulateOscillation: function (currentValue, targetValue, end) {
      const gaugeElement = document.querySelector('.gauge')
      const oscillationSteps = 50
      const oscillationDuration = 2000 // 2 seconds
      const stepValue = (targetValue - currentValue) / oscillationSteps
      let currentStep = 0
      const updateValue = () => {
        const value = currentValue + stepValue * currentStep
        this.setGaugeValue(gaugeElement, value, end)
        currentStep++
        if (currentStep <= oscillationSteps) {
          setTimeout(updateValue, oscillationDuration / oscillationSteps)
        } else {
          this.setGaugeValue(gaugeElement, targetValue, end)
        }
      }
      updateValue()
    },
    init: function () {
      setTimeout(() => {
        this.simulateOscillation(30, 10, false)
        setTimeout(() => {
          this.simulateOscillation(10, this.points, true)
        }, 50 * (2000 / 50) + 1000) // Delay before the second oscillation
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.gauge {
  width: 100%;
  max-width: 650px;
  font-family: "Roboto", sans-serif;
  font-size: 32px;
  color: #b4c0be;
  margin: 15vh auto;
}

.gauge__body {
  width: 100%;
  height: 0;
  padding-bottom: 50%;
  background: #c0bdb4;
  position: relative;
  border-top-left-radius: 100% 200%;
  border-top-right-radius: 100% 200%;
  overflow: hidden;
}

.gauge__fill {
  position: absolute;
  top: 100%;
  left: 0;
  width: inherit;
  height: 100%;
  background: #c0bdb4;
  transform-origin: center top;
  transform: rotate(0.25turn);
  transition: transform 0.2s ease-out;
}

.gauge__cover {
  width: 75%;
  height: 150%;
  background: #ffffff;
  border-radius: 50%;
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translateX(-50%);

  /* Text */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 25%;
  box-sizing: border-box;
}

.gauge__text {
  font-size: 56px;
  font-weight: bold;
  margin-bottom: 8px;
}

.gauge__score-text {
  font-size: 46px;
  color: #888;
}
.gauge__score-text.low-score,
.gauge__text.low-score {
  color: #58151c;
}
.gauge__score-text.medium-score,
.gauge__text.medium-score {
  color: #dc3545;
}
.gauge__score-text.high-score,
.gauge__text.high-score {
  color: #ffc107;
}
.gauge__score-text.excellent-score,
.gauge__text.excellent-score {
  color: #198754;
}

.gauge__fill.low-score {
  color: #58151c;
  background: #58151c;
}

.gauge__fill.medium-score {
  color: #dc3545;
  background: #dc3545;
}

.gauge__fill.high-score {
  color: #ffc107;
  background: #ffc107;
}

.gauge__fill.excellent-score {
  color: #198754;
  background: #198754;
}
</style>



// WEBPACK FOOTER //
// src/components/Gauge.vue